export default __webpack_public_path__ + "static/media/strong  5 self assesment.ab7bb7e3.webp";